import React, { useState, createContext, useContext } from 'react';
import { CalendarModal } from './CalendarModal';
interface CalendarModalContextType {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}
const CalendarModalContext = createContext<CalendarModalContextType | undefined>(undefined);
export function CalendarModalProvider({
  children
}: {
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  return <CalendarModalContext.Provider value={{
    isOpen,
    open,
    close
  }} data-id="element-2175">
      {children}
      <CalendarModal isOpen={isOpen} onClose={close} data-id="element-2176" />
    </CalendarModalContext.Provider>;
}
export function useCalendarModal() {
  const context = useContext(CalendarModalContext);
  if (context === undefined) {
    throw new Error('useCalendarModal must be used within a CalendarModalProvider');
  }
  return context;
}